import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { StoreShape } from 'hellospa/redux/types';
import HelloModal from 'common/components/hello-modal';
import { UserFile } from 'hellospa/page/prep-and-send/data/types/file';
import { getTemplateByGuid } from 'hellospa/page/prep-and-send/data/selectors';
import styles from './styles.scss';
import Button, { ButtonType } from 'hellospa/foundation/control/button';

type Props = {
  templateGuid: string,
  onClose: () => void,
  onDelete: () => void,
  isOpen: boolean,
  files: UserFile[],
}

const DeleteTemplateModal = ({ templateGuid, onClose, onDelete, isOpen, files }: Props) => {
  const template = useSelector((state: StoreShape) => {
    return getTemplateByGuid(state, templateGuid);
  });

  // this should never happen, but if it ever does there's something wrong
  if (!template) {
    throw new Error('Template does not exist!');
  }

  const cancelButton = <FormattedMessage
    id=""
    description="cancel button text for delete template modal"
    defaultMessage="Cancel" />;

  const deleteButton = <FormattedMessage
    id=""
    description="delete button text for delete template modal"
    defaultMessage="Delete template" />;

  return (
    <HelloModal
      contentLabel={
        <FormattedMessage
          id=""
          description="prep and send delete template files modal"
          defaultMessage="Delete template group?" />
      }
      onRequestClose={onClose}
      isOpen={isOpen}
      buttons={[
        <Button
          kind={ButtonType.Subtle}
          onClick={onClose}
          data-qa-ref='cancel-template-delete'
          key='cancel-delete-button-key'
        >
          {cancelButton}
        </Button>,
        <Button
          kind={ButtonType.Warning}
          onClick={onDelete}
          data-qa-ref='continue-delete-template'
          key='continue-delete-button-key'
        >
          {deleteButton}
        </Button>,
      ]}
    >
      <FormattedMessage
        id=""
        description="prep and send delete template file modal body message"
        defaultMessage="This document is part of the template group {templateName} and cannot be deleted independent from the group. If you continue, the following documents will also be removed:"
        values={{ templateName: template.document.title }} />

      <ul className={styles.templateFileList}>
        {files.map((file, i) => <li key={`${i}-${file.templateGuid}`}>- {file.name}</li>)}
      </ul>
    </HelloModal>
  );
};

export default React.memo(DeleteTemplateModal);
